import variables from '../../variables';
import {$dom} from '../../helpers/dom';
import gsap from "gsap";
import {getScroll} from '../../helpers/_utilities';
import is from 'is_js';

const {
	removeClass,
	addClass
} = $dom;
const {
	gsapDefaultDuration: duration
} = variables;
const {
	header
} = variables.dom;


let
	lastScrollTop = is.touchDevice()
		? getScroll().y
		: 0,
	headerIsVisible = true
;

function showHeader() {
	gsap.to(header, {yPercent: 0,duration});
	addClass(header, variables.classNames.active);
	headerIsVisible = true;
}

if (is.touchDevice()) showHeader();

export default function headerOnScroll(event) {

	let y;

	if (event instanceof Event) {
		y = getScroll().y + header.offsetHeight;
	} else if (typeof event === 'number') {
		y = event;
	} else {
		y = event.offset.y;
	}

	if (y <= header.offsetHeight) removeClass(header, variables.classNames.active);

	if (y > lastScrollTop) {
		if (headerIsVisible) {
			gsap.to(header, {yPercent: -100,duration});
			removeClass(header, variables.classNames.active);
			headerIsVisible = false;
		}
	} else {
		if (!headerIsVisible) {
			showHeader();
		}
	}

	lastScrollTop = y <= 0 ? 0 : y;
}
